import React from 'react';
import {AboutYouLogo} from '../../../features/AboutYouLogo/AboutYouLogo';
import {useHomePageTakeoverSection} from '../hooks/useGetHeaderBulkSection';
import {useTrackHeaderOriginClick} from '../hooks/useOriginClickTrackingFunction';

interface HeaderAboutYouLogoWrapperProps {
  className?: string;
}
export const HeaderAboutYouLogoWrapper: React.FC<
  HeaderAboutYouLogoWrapperProps
> = ({className}) => {
  const trackOriginClick = useTrackHeaderOriginClick();
  const request = useHomePageTakeoverSection();

  return (
    <AboutYouLogo
      className={className}
      disableSvgLogo
      disableLoggedInUserUpdates={false}
      trackOriginClickFunction={trackOriginClick}
      homepageTakeover={request.data}
    />
  );
};
